/**
 * API Configuration
 * Central configuration for API endpoints and settings
 */

export const API_CONFIG = {
  // Base URL from environment variable
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',

  // Timeout in milliseconds
  TIMEOUT: 30000,

  // API version
  VERSION: 'v1',

  // Endpoints
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh',
      ME: '/auth/me',
    },
    USERS: {
      LIST: '/users',
      USER_INFO: '/users/UserInfo',
      DETAIL: (id: string) => `/users/${id}`,
      CREATE: '/users',
      UPDATE: (id: string) => `/users/${id}`,
      DELETE: (id: string) => `/users/${id}`,
    },
    PROJECTS: {
      LIST: '/projects',
      DETAIL: (id: string) => `/projects/${id}`,
      CREATE: '/projects',
      UPDATE: (id: string) => `/projects/${id}`,
      DELETE: (id: string) => `/projects/${id}`,
    },
    CHAT: {
      SEND: '/chat/send',
      HISTORY: '/chat/history',
      SESSIONS: '/chat/sessions',
      QUERY: '/qa/answer',
      USER_CHATS: (userId: string) => `/chats/user/${userId}`,
      CHAT_MESSAGES: (chatId: string) => `/chats/${chatId}/messages`,
    },
    PROCUREMENT: {
      VENDORS: '/procurement/vendors',
      VENDOR_DETAIL: (id: string) => `/procurement/vendors/${id}`,
      PURCHASE_ORDERS: '/procurement/purchase-orders',
      PO_DETAIL: (id: string) => `/procurement/purchase-orders/${id}`,
      CREATE_PO: '/procurement/purchase-orders',
      UPDATE_PO: (id: string) => `/procurement/purchase-orders/${id}`,
      APPROVE_PO: (id: string) => `/procurement/purchase-orders/${id}/approve`,
      REJECT_PO: (id: string) => `/procurement/purchase-orders/${id}/reject`,
      STATS: '/procurement/stats',
    },
    INVENTORY: {
      MATERIALS: '/inventory/materials',
      MATERIAL_DETAIL: (id: string) => `/inventory/materials/${id}`,
      CREATE_MATERIAL: '/inventory/materials',
      UPDATE_MATERIAL: (id: string) => `/inventory/materials/${id}`,
      STOCK_MOVEMENTS: '/inventory/movements',
      CREATE_MOVEMENT: '/inventory/movements',
      LOW_STOCK: '/inventory/low-stock',
      STATS: '/inventory/stats',
    },
    WORK_ORDERS: {
      LIST: '/work-orders',
      DETAIL: (id: string) => `/work-orders/${id}`,
      CREATE: '/work-orders',
      UPDATE: (id: string) => `/work-orders/${id}`,
      DELETE: (id: string) => `/work-orders/${id}`,
      ASSIGN: (id: string) => `/work-orders/${id}/assign`,
      UPDATE_STATUS: (id: string) => `/work-orders/${id}/status`,
      STATS: '/work-orders/stats',
    },
    REPORTS: {
      LIST: '/reports',
      DETAIL: (id: string) => `/reports/${id}`,
      CREATE: '/reports',
      EXPORT: (id: string) => `/reports/${id}/export`,
      GENERATE: '/reports/generate',
    },
    NOTIFICATIONS: {
      LIST: '/notifications',
      MARK_READ: (id: string) => `/notifications/${id}/read`,
      MARK_ALL_READ: '/notifications/mark-all-read',
      COUNT: '/notifications/count',
    },
    DASHBOARD: {
      OVERVIEW: '/dashboard/overview',
      ANALYTICS: '/dashboard/analytics',
    },
  },
};

export default API_CONFIG;
